import { SUBJECT_KEYS } from '../pages/types/acl';
import { AP } from '../pages/types/appointments';
import DummyBridge from './DummyBridge';
import getB, { initBridge } from './EkaBridge';
import { dispatch } from './events/dispatch';
import {
    BILLING_POPUP,
    CREATE_ABHA,
    EXPORT_ALL_PT,
    INIT_MEDICAL_CERTIFICATE,
    ON_ADD_ADDRESS,
    ON_APPT_ACTION,
    ON_BILL_PATIENT,
    ON_BOOK_LAB_TEST,
    ON_CREATE_TEMPLATE,
    ON_ENTER_VITALS,
    ON_ORDER_MEDICINE,
    ON_PATIENT_EDIT_ACTION,
    ON_REFER_PATIENT,
    ON_REQUEST_MEDICAL_RECORDS,
    ON_SHOW_SA,
    OPEN_URL_IN_IFRAME_DIALOG,
    REQUEST_PAYMENT,
    SHOW_GOOGLE_REVIEW_KNOW_MORE_DIALOG,
} from './events/types';
import { DexieDbType } from './types/dexie';
import { DoctorProfile, MyProfileResponse } from './types/doctorProfile';
import { Visit } from './types/visit';

initBridge();

export const getDoc = (): DoctorProfile | undefined => {
    return getB().getDoc();
};

export const navigate = (
    type: 'push' | 'replace',
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    params,
): void => {
    return getB().navigate(type, params);
};

type GenieSettings = {
    openPrintPdfInNewTab: boolean;
    sendWelcome: boolean;
    dform: boolean;
    padV2: boolean;
    smartSuggestions: boolean;
    autoFillFollowUp: boolean;
    barcodeEnabled: boolean;
    isOrderMedicine: boolean;
    isBookLabTest: boolean;
};

export const isCanOrderMedicine = async (): Promise<boolean> => {
    try {
        // const table = await getB().getData("misc");
        // if (!table || !table.get) {
        //   return false;
        // }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // const data = await table.get("settings");
        const doctorProfile = await getDoc();
        // return Boolean(doctorProfile?.profile?.professional?.onboarded_for?.includes('HXNG'));
        return false;
    } catch (e) {
        console.error('Error in isCanOrderMedicine', e);
        return false;
    }
};

export const isCanBookLabTest = async (): Promise<boolean> => {
    try {
        // const table = await getB().getData("misc");
        // if (!table || !table.get) {
        //   return false;
        // }

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // const data = await table.get("settings");
        const doctorProfile = await getDoc();

        return Boolean(
            doctorProfile?.profile?.professional?.onboarded_for?.includes('HXNG') ||
                doctorProfile?.profile?.professional?.onboarded_for?.includes('HELB'),
        );
    } catch (e) {
        console.error('Error in isCanBookLabTest', e);
        return false;
    }
};

export const getLocalVisitByIds = async (ids: string[]): Promise<Visit[]> => {
    return getB().getLocalVisitByIds(ids);
};

export const showGoogleReviewDialog = (): void => {
    dispatch({
        type: SHOW_GOOGLE_REVIEW_KNOW_MORE_DIALOG,
    });
};

export const exportPtAsExcel = (): void => {
    dispatch({
        type: EXPORT_ALL_PT,
    });
};

export const initMedicalCertificate = (ap: AP): void => {
    dispatch({
        type: INIT_MEDICAL_CERTIFICATE,
        ap,
    });
};

export const toggleIframeActionDialog = (url: string): void => {
    dispatch({
        type: OPEN_URL_IN_IFRAME_DIALOG,
        url,
    });
};

export const onAppointmentAction = (a: AP, cId: string): void => {
    dispatch({
        type: ON_APPT_ACTION,
        a,
        cId,
    });
};

export const onRequestPaymentAction = (a: AP): void => {
    const { service } = a;
    dispatch({
        type: REQUEST_PAYMENT,
        data: {
            aid: a.aid,
            patient: a.patient,
            uhid: a.formData?.find((fd) => fd.key === 'uhid')?.value?.toString() || null,
            clinicId: a.clinic_id,
            source: 'request-payment',
            aptDate: a.date,
            ...(service &&
                service.conf_id !== 'fallback-conf' && {
                    serviceInfo: {
                        id: service.service_id,
                        name: service.service_name,
                        price: service.price || 0,
                    },
                }),
        },
    });
};

export const onPatientEditAction = (appointment: AP): void => {
    dispatch({
        type: ON_PATIENT_EDIT_ACTION,
        a: appointment,
    });
};

export const onBillingPopupAction = (a: AP): void => {
    const { service } = a;
    dispatch({
        type: BILLING_POPUP,
        data: {
            aid: a.aid,
            patient: a.patient,
            uhid: a.formData?.find((fd) => fd.key === 'uhid')?.value?.toString() || null,
            clinicId: a.clinic_id,
            source: 'apt-queue',
            aptDate: a.date,
            ...(service &&
                service.conf_id !== 'fallback-conf' && {
                    serviceInfo: {
                        id: service.service_id,
                        name: service.service_name,
                        price: service.price || 0,
                    },
                }),
            appointment: a,
        },
    });
};

export const onViewReceiptsPopupAction = (a: AP): void => {
    dispatch({
        type: BILLING_POPUP,
        data: {
            aid: a.aid,
            patient: a.patient,
            uhid: a.formData?.find((fd) => fd.key === 'uhid')?.value?.toString() || null,
            clinicId: a.clinic_id,
            source: 'apt-queue-view-receipts',
            aptDate: a.date,
            appointment: a,
        },
    });
};

export const onSettleDuePopupAction = (a: AP): void => {
    dispatch({
        type: BILLING_POPUP,
        data: {
            aid: a.aid,
            patient: a.patient,
            uhid: a.formData?.find((fd) => fd.key === 'uhid')?.value?.toString() || null,
            clinicId: a.clinic_id,
            source: 'settle-due',
            aptDate: a.date,
            appointment: a,
        },
    });
};

export const onRequestMedicalRecordsAction = (a: AP): void => {
    dispatch({
        type: ON_REQUEST_MEDICAL_RECORDS,
        a,
    });
};

export const onAddAddressAction = (a: AP): void => {
    dispatch({
        type: ON_ADD_ADDRESS,
        a,
    });
};

export const onBillPatientAction = (a: AP): void => {
    dispatch({
        type: ON_BILL_PATIENT,
        a,
    });
};

export const onReferAdocAction = (a: AP): void => {
    dispatch({
        type: ON_REFER_PATIENT,
        a,
    });
};

export const onAddVitalsAction = (a: AP): void => {
    dispatch({
        type: ON_ENTER_VITALS,
        a,
    });
};

export const onCreateAbha = (a: AP): void => {
    dispatch({
        type: CREATE_ABHA,
        a,
    });
};

export const onOrderMedicineAction = (a: AP): void => {
    dispatch({
        type: ON_ORDER_MEDICINE,
        a,
    });
};

export const onBookLabTestAction = (a: AP): void => {
    dispatch({
        type: ON_BOOK_LAB_TEST,
        a,
    });
};

export const onShowSAAction = (a: AP): void => {
    dispatch({
        type: ON_SHOW_SA,
        a,
    });
};

export const onCreateTemplateAction = (a: AP): void => {
    dispatch({
        type: ON_CREATE_TEMPLATE,
        a,
    });
};

const DB_TABLE_D_FORMS = 'dForms';

export async function getEnabledDynamicFormFields(): Promise<DFormEntity[]> {
    const bridge = getB();
    const item = await bridge?.getData(DB_TABLE_D_FORMS);
    if (item) {
        const enabledFormFieldData = await item.get?.('addp');
        if (enabledFormFieldData) {
            return enabledFormFieldData.value;
        }
    }
    return [];
}

export function isHmisEnabled(): Promise<boolean> {
    return getB().isHmisEnabled();
}

export interface DFormEntity {
    label: string;
    type: 'string' | 'number' | 'select';
    key: string;
}

export function getIdb(): DexieDbType {
    return getB()?.getIdb?.();
}

export function getMe(): {
    doctors: MyProfileResponse['docs'];
    clinics: MyProfileResponse['clinics'];
    business: MyProfileResponse['business'];
} {
    const { docs, clinics, business, loginmeta } = getB()?.getMe();
    return {
        doctors: docs,
        clinics,
        business: { ...business, id: business?.id || `b-${loginmeta.docid}` },
    };
}

export function isDoctorOnly(): boolean {
    return getB().amIDoctorOnly();
}

export function isAccessAvailable(name: SUBJECT_KEYS) {
    const bridge = getB();
    const isAccessAvailable = bridge.isAccessAvailable(name);
    return isAccessAvailable;
}

export function showAccessDeniedError() {
    const bridge = getB();
    bridge.showAccessDeniedError();
}
